import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  ViewChildren,
  ChangeDetectorRef,
} from '@angular/core';

import { SelectItem, LazyLoadEvent } from 'primeng';
import { IPageResult } from '../../interfaces/page-result';
import { IPremium } from '../../interfaces/premium';
import { IPremiumFilter } from '../../interfaces/premium-filter';
import { PremiumService } from '../../services';
import { ConfirmationService } from 'primeng';
import { InputHelper } from '../../utils/input.helper';
import { compare } from 'fast-json-patch';

@Component({
  selector: 'manage-premiums',
  templateUrl: './manage-premiums.component.html',
  styleUrls: ['./manage-premiums.component.scss'],
  providers: [InputHelper],
})
export class ManagePremiumsComponent implements OnInit {
  @Input() isPricingAdmin: boolean;
  public backTo: string;
  public isActiveCheckList: boolean = false;

  public page: IPageResult<IPremium> = {
    items: [],
    total: 0,
  };
  public selectedItem: any;

  public event: any;
  public filter: Subject<IPremiumFilter>;
  public filterVal: IPremiumFilter;
  public isLoaded: boolean = false;
  public filterString: string;

  public showAddPostcodeDlg: boolean = false;
  public pItem: IPremium = { id: 0 };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private premiumService: PremiumService,
    private changeDetector: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
    public inputHelper: InputHelper,
  ) {}

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.initDefaultFilter();

    this.filter = new Subject<IPremiumFilter>();
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filter.next(this.filterVal);
  }

  load(filter: IPremiumFilter) {
    this.premiumService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      //rows: 10,
      sortField: 'postcode',
      sortOrder: 1,
      filters: {},
    };
  }

  clearFilter() {
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  cellEdit(item) {
    this.premiumService.save(item).then((x) => {
      item.customerWeight = x.customerWeight;
      item.supplierWeight = x.supplierWeight;
      item.postcode = x.postcode;
      item.comments = x.comments;
      item.updatedByUserName = x.updatedByUserName;
      item.updatedOn = x.updatedOn;
    });
  }
}
